import { render, staticRenderFns } from "./addChainSupplierProduct.vue?vue&type=template&id=aa4359c6&scoped=true"
import script from "./addChainSupplierProduct.vue?vue&type=script&lang=js"
export * from "./addChainSupplierProduct.vue?vue&type=script&lang=js"
import style0 from "./addChainSupplierProduct.vue?vue&type=style&index=0&id=aa4359c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4359c6",
  null
  
)

export default component.exports